import * as i0 from '@angular/core';
import { EventEmitter, Component, ChangeDetectionStrategy, Input, Output, HostBinding, NgModule } from '@angular/core';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@fortawesome/angular-fontawesome';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import * as i1 from 'ngx-sharebuttons';
import { SHARE_BUTTONS_CONFIG, ShareModule } from 'ngx-sharebuttons';
function ShareButton_div_2_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelement(1, "fa-icon", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    const btn_r3 = i0.ɵɵreference(1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("icon", ctx_r1.icon || btn_r3.icon)("fixedWidth", true);
  }
}
function ShareButton_div_2_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    const btn_r3 = i0.ɵɵreference(1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.text || btn_r3.text, " ");
  }
}
function ShareButton_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtemplate(1, ShareButton_div_2_div_1_Template, 2, 2, "div", 4)(2, ShareButton_div_2_div_2_Template, 2, 1, "div", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const btn_r3 = i0.ɵɵreference(1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showIcon && btn_r3.icon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showText);
  }
}
let ShareButton = /*#__PURE__*/(() => {
  class ShareButton {
    /** Set theme as button class */
    get buttonClass() {
      return `sb-button sb-${this.theme}`;
    }
    constructor(_share) {
      this._share = _share;
      /** Sets the fb messenger redirect url to enable sharing on Messenger desktop */
      this.redirectUrl = this._share.config.redirectUrl;
      /** Show button icon */
      this.showIcon = true;
      /** Show button text */
      this.showText = false;
      /** Button theme */
      this.theme = this._share.config.theme;
      /** Stream that emits when share dialog is opened */
      this.opened = new EventEmitter();
      /** Stream that emits when share dialog is closed */
      this.closed = new EventEmitter();
    }
    static {
      this.ɵfac = function ShareButton_Factory(t) {
        return new (t || ShareButton)(i0.ɵɵdirectiveInject(i1.ShareService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ShareButton,
        selectors: [["share-button"]],
        hostVars: 2,
        hostBindings: function ShareButton_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.buttonClass);
          }
        },
        inputs: {
          button: "button",
          url: "url",
          title: "title",
          description: "description",
          image: "image",
          tags: "tags",
          redirectUrl: "redirectUrl",
          autoSetMeta: "autoSetMeta",
          showIcon: "showIcon",
          showText: "showText",
          text: "text",
          icon: "icon",
          theme: "theme",
          disabled: "disabled"
        },
        outputs: {
          opened: "opened",
          closed: "closed"
        },
        decls: 3,
        vars: 14,
        consts: [["btn", "shareButton"], ["type", "button", 1, "sb-wrapper", 3, "opened", "closed", "shareButton", "url", "image", "title", "description", "tags", "redirectUrl", "autoSetMeta", "disabled"], ["class", "sb-content", 4, "ngIf"], [1, "sb-content"], ["class", "sb-icon", 4, "ngIf"], ["class", "sb-text", 4, "ngIf"], [1, "sb-icon"], [3, "icon", "fixedWidth"], [1, "sb-text"]],
        template: function ShareButton_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "button", 1, 0);
            i0.ɵɵlistener("opened", function ShareButton_Template_button_opened_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.opened.emit($event));
            })("closed", function ShareButton_Template_button_closed_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.closed.emit($event));
            });
            i0.ɵɵtemplate(2, ShareButton_div_2_Template, 3, 2, "div", 2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            const btn_r3 = i0.ɵɵreference(1);
            i0.ɵɵclassProp("sb-show-icon", ctx.showIcon)("sb-show-text", ctx.showText);
            i0.ɵɵproperty("shareButton", ctx.button)("url", ctx.url)("image", ctx.image)("title", ctx.title)("description", ctx.description)("tags", ctx.tags)("redirectUrl", ctx.redirectUrl)("autoSetMeta", ctx.autoSetMeta)("disabled", ctx.disabled);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", btn_r3);
          }
        },
        dependencies: [i1.ShareDirective, i2.FaIconComponent, i3.NgIf],
        styles: ["[button=facebook][_nghost-%COMP%], [button=facebook]   [_nghost-%COMP%]{--button-color: #4267B2}[button=twitter][_nghost-%COMP%], [button=twitter]   [_nghost-%COMP%]{--button-color: #00acee}[button=google][_nghost-%COMP%], [button=google]   [_nghost-%COMP%]{--button-color: #db4437}[button=mix][_nghost-%COMP%], [button=mix]   [_nghost-%COMP%]{--button-color: #ff8226}[button=line][_nghost-%COMP%], [button=line]   [_nghost-%COMP%]{--button-color: #00b900}[button=linkedin][_nghost-%COMP%], [button=linkedin]   [_nghost-%COMP%]{--button-color: #006fa6}[button=pinterest][_nghost-%COMP%], [button=pinterest]   [_nghost-%COMP%]{--button-color: #bd081c}[button=reddit][_nghost-%COMP%], [button=reddit]   [_nghost-%COMP%]{--button-color: #ff4006}[button=tumblr][_nghost-%COMP%], [button=tumblr]   [_nghost-%COMP%]{--button-color: #36465d}[button=whatsapp][_nghost-%COMP%], [button=whatsapp]   [_nghost-%COMP%]{--button-color: #25d366}[button=messenger][_nghost-%COMP%], [button=messenger]   [_nghost-%COMP%]{--button-color: #0080FF}[button=telegram][_nghost-%COMP%], [button=telegram]   [_nghost-%COMP%]{--button-color: #0088cc}[button=xing][_nghost-%COMP%], [button=xing]   [_nghost-%COMP%]{--button-color: #006567}[button=sms][_nghost-%COMP%], [button=sms]   [_nghost-%COMP%]{--button-color: #20c16c}[button=email][_nghost-%COMP%], [button=email]   [_nghost-%COMP%]{--button-color: #FF961C}[button=viber][_nghost-%COMP%], [button=viber]   [_nghost-%COMP%]{--button-color: #665ca7}[button=vk][_nghost-%COMP%], [button=vk]   [_nghost-%COMP%]{--button-color: #4C75A3}[button=copy][_nghost-%COMP%], [button=copy]   [_nghost-%COMP%]{--button-color: #607D8B}[button=print][_nghost-%COMP%], [button=print]   [_nghost-%COMP%]{--button-color: #765AA2}[button=expand][_nghost-%COMP%], [button=expand]   [_nghost-%COMP%]{--button-color: #FF6651}button[_ngcontent-%COMP%]{cursor:pointer;position:relative;outline:0;-webkit-print-color-adjust:exact;margin:var(--sb-margin, .3125em);padding:var(--sb-padding, 0);min-width:var(--sb-min-width, 4.125em);height:var(--sb-height, 2.5em);color:var(--sb-color, #fff);background:var(--sb-background);font-size:var(--sb-font-size, 13px);line-height:var(--sb-line-height, 2.571em);border:var(--sb-border);border-radius:var(--sb-border-radius);transition:var(--sb-transition);box-shadow:var(--sb-box-shadow);text-shadow:var(--sb-text-shadow);overflow:var(--sb-overflow)}.sb-icon[_ngcontent-%COMP%], .sb-text[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;-webkit-user-select:none;-moz-user-select:none;user-select:none}.sb-content[_ngcontent-%COMP%]{flex:1;display:flex;height:100%;width:100%;position:relative}.sb-text[_ngcontent-%COMP%]{flex:1;height:100%;white-space:nowrap;padding:var(--sb-text-padding, 0 .7em);font-weight:var(--sb-font-weight, bold)}.sb-icon[_ngcontent-%COMP%]{text-align:center;width:100%;height:100%;min-width:2em;font-size:var(--sb-icon-size, 1.2em)}"],
        changeDetection: 0
      });
    }
  }
  return ShareButton;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ShareButtonModule = /*#__PURE__*/(() => {
  class ShareButtonModule {
    static withConfig(config) {
      return {
        ngModule: ShareButtonModule,
        providers: [{
          provide: SHARE_BUTTONS_CONFIG,
          useValue: config
        }]
      };
    }
    static {
      this.ɵfac = function ShareButtonModule_Factory(t) {
        return new (t || ShareButtonModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: ShareButtonModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [ShareModule, FontAwesomeModule, CommonModule, ShareModule, FontAwesomeModule]
      });
    }
  }
  return ShareButtonModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { ShareButton, ShareButtonModule };
